import axiosInstance from '../AxiosInstance';
import Api from '../../constants/Api';

const CompanyProvisionService = {
    create(payload) {
        return axiosInstance.post(Api.registration.company_provision, payload);
    },
    pageable(payload) {
        return axiosInstance.post(`${Api.registration.company_superadmin}/pageable`, payload);
    },
    findById(id) {
        return axiosInstance.get(`${Api.registration.company_superadmin}/${id}`);
    },
    lookupCnpj(cnpj) {
        return axiosInstance.get(`${Api.registration.company_cnpj_lookup}/${cnpj}`);
    },
    update(id, payload) {
        return axiosInstance.patch(`${Api.registration.company_superadmin}/${id}`, payload);
    }
};

export default CompanyProvisionService;
